import React from 'react';
import PropTypes from 'prop-types';

import { GridItem } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import Spacing from '@marvelapp/marvel-ui/spacing';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';

export default function FooterColumn({ children, title, className, columns }) {
  return (
    <GridItem
      columnSpan={6}
      columnSpanM={2}
      columns={columns}
      justifyContent="flex-start"
    >
      <div className={className}>
        <Spacing type="margin" size="s" position="topBottom">
          <Heading tag="h3" size="xl" color="white" weight="semibold">
            {title}
          </Heading>
        </Spacing>
        {children}
      </div>
    </GridItem>
  );
}

FooterColumn.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  columns: PropTypes.number,
  title: propTypeEmptyString,
};



// WEBPACK FOOTER //
// ./src/components/modules/Footer/FooterColumn/index.js